import * as angular from 'angular';
export class RedirectionLandingService {


    constructor ( private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant, private RedirectionService: any,
        private $window : ng.IWindowService, private $rootScope: CommonsRootScope) {
        this.$rootScope.$on('redirectLandingSubscriptionModels', (event: angular.IAngularEvent, data: { market: string, lang: string }) => this.redirection(data.market, data.lang));
    }

    redirection = (market: string, lang: string): void => {
        if (market !== 'ja' && market !== 'zh') {
            this.RedirectionService.externalRedirect(`${this.$window.location.origin}/${market}${this.SubscriptionModelsAppConstants.LANDING_URL[lang]}`);
        } else {
            this.RedirectionService.externalRedirect(`${this.$window.location.origin}/${this.SubscriptionModelsAppConstants.LANDING_URL.ES}`);
        }
    };
}
RedirectionLandingService.$inject = [
    'SubscriptionModelsAppConstants',
    'RedirectionService',
    '$window',
    '$rootScope'
];
try {
    const mod = angular.module('ib-subscription-models-service-module');
    mod.service(
        'RedirectionLandingService',
        RedirectionLandingService
    );
} catch (error) {
    const mod = angular.module('ib-subscription-models-service-module', []);
    mod.service(
        'RedirectionLandingService',
        RedirectionLandingService
    );
}